import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "chargeDate"]
  static values = { hasExistingInstallments: Boolean }

  connect() {
    this.checkExistingInstallments()
    this.toggleChargeDate()
  }

  checkExistingInstallments() {
    if (this.hasExistingInstallmentsValue) {
      this.checkboxTarget.disabled = true
      this.checkboxTarget.checked = false
    }
  }

  // Payable upon registration derives the date server-side
  // (Admission::FeeInstallment#set_charge_at_for_registration_payment). A disabled input is
  // already barred from HTML constraint validation; `required` is cleared too rather than
  // relying on that.
  toggleChargeDate() {
    if (this.checkboxTarget.checked) {
      this.chargeDateTarget.disabled = true
      this.chargeDateTarget.required = false
      this.chargeDateTarget.value = ""
    } else {
      this.chargeDateTarget.disabled = false
      this.chargeDateTarget.required = true
    }
  }
}
